import images from '~/constants/images';
import ErrorPageBall from './ErrorPageBall.png';
import ErrorPageLogo from './laliga-logo.png';

const ErrorPageBeat = images.beat;
export { ErrorPageLogo, ErrorPageBall, ErrorPageBeat };
